import { Component } from '@angular/core';

/**
 */
@Component({
  selector: 'app-password-recovery-info',
  templateUrl: './password-recovery-info.component.html',
  styleUrls: ['./password-recovery-info.component.scss'],
})
export class PasswordRecoveryInfoComponent {}
